import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 18c-1.9 0-3.71.73-5.08 2.04a.996.996 0 0 0-.03 1.41c.2.21.46.31.72.31.25 0 .5-.09.69-.28 1-.96 2.31-1.49 3.7-1.49s2.7.53 3.7 1.49a.996.996 0 1 0 1.38-1.44A7.3 7.3 0 0 0 16 18M26.41 10l2.29-2.29a.996.996 0 1 0-1.41-1.41L25 8.59 22.71 6.3a.996.996 0 1 0-1.41 1.41L23.59 10l-2.29 2.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l2.29-2.29 2.29 2.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L26.43 10zM16.01 8c.62 0 1.25.04 1.88.11.55.06 1.04-.33 1.11-.88.06-.55-.33-1.04-.88-1.11Q17.07 6 16.02 6h-.07c-5.1 0-9.89 1.98-13.52 5.56a.987.987 0 0 0 0 1.41.99.99 0 0 0 1.41.01C7.08 9.76 11.38 8 15.95 8zM16 14q.915 0 1.83.15a.999.999 0 0 0 .33-1.97c-.72-.12-1.45-.18-2.16-.18-3.55-.01-6.83 1.33-9.33 3.8a.996.996 0 0 0-.01 1.41.99.99 0 0 0 1.41.01c2.11-2.08 4.91-3.23 7.88-3.23H16zM16 26.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
  </svg>
);
const SvgIconWifiX = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWifiX);
export default Memo;
